var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLineDownArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.45603 18.3531C7.48561 18.3802 7.51793 18.4044 7.55252 18.4257L7.60077 18.449L7.66176 18.4795L7.72548 18.4983L7.78147 18.5125C7.86522 18.5287 7.95215 18.5287 8.03636 18.5125L8.09234 18.4983L8.15606 18.4795L8.21706 18.449L8.2653 18.4257C8.30035 18.4044 8.33267 18.3802 8.36225 18.3531L14.6658 12.5657C14.8756 12.3337 14.8583 11.9932 14.6257 11.78C14.3931 11.5668 14.0217 11.5509 13.7687 11.7433L8.54341 16.5377V1.58412C8.54341 1.2616 8.25802 1 7.90618 1C7.55434 1 7.26895 1.2616 7.26895 1.58412V16.5377L2.0437 11.7433C1.79063 11.5509 1.41922 11.5668 1.18663 11.78C0.954042 11.9932 0.936746 12.3337 1.14658 12.5657L7.45512 18.3531H7.45603Z",
    fill: "#6479F8",
    stroke: "#6479F8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineDownArrow);
export default __webpack_public_path__ + "static/media/line-down-arrow.31a54cdb2bf10be45e33c1f5cfd6d9a6.svg";
export { ForwardRef as ReactComponent };